import { ElementContainer } from "../../../../../library-js/dom-tools/ElementContainer";
import { AudioEditorUI } from "./AudioEditorUI";

export abstract class AudioEditorUIComponent<T extends Element> extends ElementContainer<T>
{
  protected _ui:AudioEditorUI;
  get ui(){ return this._ui; }

  constructor( ui:AudioEditorUI )
  {
    super();
    this._ui = ui;
  }

  abstract initialize():Promise<void>;
  

  

}